module.exports = __webpack_public_path__ + "static/img/home_04.09c75f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_04.png
// module id = LaFJ
// module chunks = 34